module.exports = __webpack_public_path__ + "img/banner_text.e4417715.png";